module.exports = __webpack_public_path__ + "img/1_1-residenziale-villette_singole-0.f98344f6.png";